import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_3 = { class: "relative bg-white border border-gray-200 dark:border-gray-700 dark:bg-black rounded-lg shadow-xl max-w-md w-full" }
const _hoisted_4 = { class: "flex justify-center pt-8" }
const _hoisted_5 = { class: "px-6 pb-8 pt-4 flex justify-center" }

import { useBrand } from '@/composables/brand/useBrand';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompleteProfileModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["complete"],
  setup(__props: any) {





const { brandColors } = useBrand();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "w-16 h-16 rounded-full flex items-center justify-center",
                      style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary + '20' })
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        class: "w-8 h-8",
                        style: _normalizeStyle({ color: _unref(brandColors).primary })
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z",
                          "clip-rule": "evenodd"
                        }, null, -1)
                      ]), 4))
                    ], 4)
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "px-6 pt-5 pb-2 text-center" }, [
                    _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white mb-2" }, " Complete Your Profile "),
                    _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400" }, [
                      _createTextVNode(" Please complete your profile by providing your "),
                      _createElementVNode("strong", null, "Mobile Number"),
                      _createTextVNode(" and "),
                      _createElementVNode("strong", null, "City"),
                      _createTextVNode(" to continue using the system. ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('complete'))),
                      class: "px-6 py-2.5 text-white rounded-lg transition-all duration-200 font-medium flex items-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
                      style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                    }, _cache[2] || (_cache[2] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        class: "w-5 h-5 mr-2"
                      }, [
                        _createElementVNode("path", { d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" }),
                        _createElementVNode("path", { d: "M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" })
                      ], -1),
                      _createTextVNode(" Complete Profile ")
                    ]), 4)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})